
export default {
  props: {
    block: {
      type: Array,
      default: () => [],
    },
    cardBackground: {
      type: String,
      default: ``,
    },
  },
  methods: {
    getImageSrc (imageItem) {
      return imageItem.image.sizes[`1536x1536`] || imageItem.image.sizes[`post-thumbnail`];
    },
  },
};
